export var CaseLocationPurposeType;
(function (CaseLocationPurposeType) {
    CaseLocationPurposeType[CaseLocationPurposeType["UNKNOWN"] = 0] = "UNKNOWN";
    CaseLocationPurposeType[CaseLocationPurposeType["CORPORATEHEADQUARTERS"] = 1] = "CORPORATEHEADQUARTERS";
    CaseLocationPurposeType[CaseLocationPurposeType["SALESOFFICE"] = 2] = "SALESOFFICE";
    CaseLocationPurposeType[CaseLocationPurposeType["RESIDENTIALADDRESS"] = 3] = "RESIDENTIALADDRESS";
    CaseLocationPurposeType[CaseLocationPurposeType["WORKADDRESS"] = 4] = "WORKADDRESS";
    CaseLocationPurposeType[CaseLocationPurposeType["SEASONALADDRESS"] = 5] = "SEASONALADDRESS";
    CaseLocationPurposeType[CaseLocationPurposeType["MAILINGADDRESS"] = 6] = "MAILINGADDRESS";
    CaseLocationPurposeType[CaseLocationPurposeType["BILLINGADDRESS"] = 7] = "BILLINGADDRESS";
    CaseLocationPurposeType[CaseLocationPurposeType["SHIPPINGADDRESS"] = 8] = "SHIPPINGADDRESS";
})(CaseLocationPurposeType || (CaseLocationPurposeType = {}));
//# sourceMappingURL=CaseLocationPurposeType.js.map